"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-statebrowser-channel-wrapper"
  }, [_c('div', {
    staticClass: "app-statebrowser-channel",
    class: {
      'app-statebrowser-channel-active': _vm.isActiveBuffer(),
      'app-statebrowser-channel-notjoined': _vm.buffer.isChannel() && !_vm.buffer.joined
    },
    attrs: {
      "data-name": _vm.buffer.name.toLowerCase()
    }
  }, [_vm.buffer.isChannel() && _vm.isAccueil ? _c('span', {
    staticClass: "app-chan-icon app-chan-icon--home",
    on: {
      "click": function ($event) {
        return _vm.$emit('selected');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.707 2.293a1 1 0 0 0-1.414 0l-7 7A1 1 0 0 0 3 11h1v6a1 1 0 0 0 1 1h4v-4h2v4h4a1 1 0 0 0 1-1v-6h1a1 1 0 0 0 .707-1.707l-7-7z"
    }
  })])]) : _vm.buffer.isChannel() ? _c('span', {
    staticClass: "app-chan-icon app-chan-icon--hash",
    on: {
      "click": function ($event) {
        return _vm.$emit('selected');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9.243 3.03a1 1 0 0 1 .727 1.213L9.53 6h2.94l.56-2.243a1 1 0 1 1 1.94.486L14.53 6H17a1 1 0 1 1 0 2h-2.97l-.8 3.2H16a1 1 0 1 1 0 2h-3.17l-.56 2.243a1 1 0 1 1-1.94-.486L10.87 13H7.93l-.56 2.243a1 1 0 1 1-1.94-.486L5.87 13H3a1 1 0 1 1 0-2h3.37l.8-3.2H4a1 1 0 0 1 0-2h3.57l.56-2.243a1 1 0 0 1 1.213-.727zM9.13 8l-.8 3.2h2.94l.8-3.2H9.13z",
      "clip-rule": "evenodd"
    }
  })])]) : _vm.buffer.isQuery() ? _c('span', {
    staticClass: "app-chan-icon app-chan-icon--query",
    on: {
      "click": function ($event) {
        return _vm.$emit('selected');
      }
    }
  }, [_vm.awayNotifySupported() ? _c('away-status-indicator', {
    attrs: {
      "network": _vm.network,
      "user": _vm.queryUser
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "app-statebrowser-channel-name",
    on: {
      "click": function ($event) {
        return _vm.$emit('selected');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.displayName) + " ")]), _c('div', {
    staticClass: "app-statebrowser-buffer-actions"
  }, [_c('div', {
    staticClass: "app-statebrowser-channel-labels"
  }, [(0, _flags.default)(_vm.buffer).unread && _vm.showMessageCounts(_vm.buffer) ? _c('div', {
    staticClass: "app-statebrowser-channel-label",
    class: [(0, _flags.default)(_vm.buffer).highlight ? 'app-statebrowser-channel-label--highlight' : '']
  }, [_vm._v(" " + _vm._s((0, _flags.default)(_vm.buffer).unread > 999 ? "999+" : (0, _flags.default)(_vm.buffer).unread) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "app-statebrowser-channel-leave",
    on: {
      "click": function ($event) {
        return _vm.maybePromptClose();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _c('transition-expand', [_vm.showPromptClose ? _c('div', {
    staticClass: "app-statebrowser-prompt-close"
  }, [_c('span', [_vm._v(_vm._s(_vm.buffer.isChannel() ? _vm.$t('prompt_leave_channel') : _vm.$t('prompt_close_query')))]), _c('input-confirm', {
    attrs: {
      "flip-connotation": true
    },
    on: {
      "ok": function ($event) {
        return _vm.closeBuffer();
      },
      "submit": function ($event) {
        return _vm.maybePromptClose();
      }
    }
  })], 1) : _vm._e()])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];